import { set, unset, values } from 'lodash';
import type {
  IGcfProductListGroup,
  IGcfProductListGroups,
} from 'src/interfaces';
import { type IGcfProductList } from 'src/interfaces';
import { ComponentTypes } from 'src/interfaces/ComponentTypesList';

import { SingleCategoryProducts } from './components';
import { ColumnList } from './components/columnList/ColumnList';
import { useProductsSidebar } from './ProductsSidebar.helper';
import { ProductsSidebarProps } from './ProductsSidebar.interface';

export const ProductsSidebar = (props: ProductsSidebarProps) => {
  const { showComponents } = useProductsSidebar(props.componentType);

  const isSingleCategory =
    props.componentType === ComponentTypes.SINGLE_SHELF ||
    props.componentType === ComponentTypes.PROMOTIONAL_SPACE;

  const isMultipleCategories =
    props.componentType === ComponentTypes.LISTING_WITH_OPTIONAL_VISUALS ||
    props.componentType === ComponentTypes.LISTING_VISUALS_GALLERY ||
    props.componentType === ComponentTypes.COMBO_STYLE;

  const productList = (props.componentConfig?.productList ??
    {}) as IGcfProductList;

  const handleGroupChange =
    (operation: 'add' | 'update' | 'delete', replaceAll: boolean = false) =>
    (value: IGcfProductListGroup | IGcfProductListGroup[]) => {
      const processGroup = (
        group: IGcfProductListGroup,
        groups: IGcfProductListGroups,
      ) => {
        switch (operation) {
          case 'add':
          case 'update':
            return set({ ...groups }, group.order, group);
          case 'delete':
            const newGroups = { ...groups };
            unset(newGroups, group.order);

            return newGroups;

          default:
            return groups;
        }
      };

      let newGroups = replaceAll ? {} : { ...productList.groups };

      if (Array.isArray(value)) {
        value.forEach((group) => {
          newGroups = processGroup(group, newGroups);
        });
      } else {
        newGroups = processGroup(value, newGroups);
      }

      props.onChangedComponentConfigField(`productList.groups`, newGroups);
    };

  return (
    <>
      {isSingleCategory && (
        <SingleCategoryProducts
          groupNumber={1}
          group={values(productList?.groups ?? {})[0]}
          showComponents={showComponents}
          componentType={props.componentType}
          productCategoryIDs={props.productCategoryIDs}
          themeId={props.themeId}
          handleGroupChange={(method, group) =>
            handleGroupChange(method)(group)
          }
          componentConfig={props.componentConfig}
        />
      )}

      {isMultipleCategories && (
        <ColumnList
          groups={productList.groups}
          showComponents={showComponents}
          componentType={props.componentType}
          productCategoryIDs={props.productCategoryIDs}
          themeId={props.themeId}
          handleGroupChange={handleGroupChange}
          componentConfig={props.componentConfig}
        />
      )}
    </>
  );
};
